module.exports = __webpack_public_path__ + "img/Media-Pictures.65d54935.svg";